module.exports = __webpack_public_path__ + "img/vue.9a45fc76.svg";